import firebase from 'firebase/app';
import db from './../firebaseInit';
import incrementGlobalAppStat from './incrementGlobalAppStat';
import {NUM_USERS} from './../constants/globalAppStatFields';
import {AVATARS, DEFAULT_OVERRIDE_OS_DARK_MODE, DEFAULT_COLOR_SCHEME} from './../constants/globalConstants';

const createUserRecord = (email, uid, callbackFunc = null) => {
  const currentUser = firebase.auth().currentUser;
  db.collection('users')
    .doc(uid)
    .set({
      accountCreatedAt: firebase.firestore.FieldValue.serverTimestamp(),
      accountLastModifiedAt: null,
      avatarToUse: AVATARS.DEFAULT,
      numTimesLoggedIn: 0,
      numTimesLoggedOut: 0,
      country: '',
      customAvatarFilename: '',
      customAvatarUrl: '',
      email: email,
      emailVerified: false,
      enabled: true,
      firstName: '',
      gamerTag: '',
      lastLoggedInAt: null,
      lastLoggedOutAt: '',
      lastName: '',
      overrideOsDarkMode: DEFAULT_OVERRIDE_OS_DARK_MODE,
      playSoundEffects: true,
      prefersColorScheme: DEFAULT_COLOR_SCHEME,
      roles: {
        admin: false,
        editor: false,
        player: true,
      },
      starredBoards: [],
      userId: uid,
      userIdShort: uid.substr(0, 8),
      yearBorn: '',
    })
    .then(function(documentData) {
      incrementGlobalAppStat(NUM_USERS);
      if (callbackFunc) {
        callbackFunc();
      }
    })
    .catch(function(error) {
      // console.error('Error adding user activity log: ', error);
      if (callbackFunc) {
        callbackFunc();
      }
    });
};

export default createUserRecord;
